import { PAYMENT_METHOD, type PaymentMethodEnumBaseData, type PaymentMethodEnumBaseExtraData, paymentMethodEnumBase } from '@nfctron/nexus-core';
import { type SvgIconComponent } from '@nfctron/nexus-react';
import { ApplePayLogo, GooglePayShortLogo, McClickToPayBlackLogo } from '@nfctron/nexus-react-svg';

import { BanknoteIcon, CreditCardIcon } from 'lucide-react';

import { EnumHelper } from './helpers';

export interface PaymentMethodEnumTicketsExtraDataExtend {
	Icon?: SvgIconComponent;
}

export interface PaymentMethodEnumTicketsData extends PaymentMethodEnumBaseData, PaymentMethodEnumTicketsExtraDataExtend {}

/**
 * Payment method enumeration with extra data for Tickets.
 * @extends {typeof paymentMethodEnumBase} Base payment method enumeration
 */
class PaymentMethodEnumTickets extends EnumHelper<
	PaymentMethodEnumBaseExtraData,
	PAYMENT_METHOD,
	typeof paymentMethodEnumBase.enumName,
	typeof paymentMethodEnumBase.idKey,
	PaymentMethodEnumTicketsExtraDataExtend
> {
	constructor() {
		super(paymentMethodEnumBase.enumName, paymentMethodEnumBase.data, paymentMethodEnumBase.idKey, {
			[PAYMENT_METHOD.CREDIT_CARD]: {
				Icon: CreditCardIcon,
			},
			[PAYMENT_METHOD.BANK_TRANSFER]: {
				Icon: BanknoteIcon,
			},
			[PAYMENT_METHOD.GOOGLE_PAY]: {
				Icon: GooglePayShortLogo,
			},
			[PAYMENT_METHOD.APPLE_PAY]: {
				Icon: ApplePayLogo,
			},
			[PAYMENT_METHOD.CLICK_TO_PAY]: {
				Icon: McClickToPayBlackLogo,
			},
			[PAYMENT_METHOD.CARD_TERMINAL]: {},
			[PAYMENT_METHOD.CASH]: {},
			[PAYMENT_METHOD.CHIP]: {},
			[PAYMENT_METHOD.VIP]: {},
			[PAYMENT_METHOD.PASS_VOUCHER]: {},
			[PAYMENT_METHOD.ORGANIZER]: {},
		});
	}
}

export const paymentMethodEnumTickets = new PaymentMethodEnumTickets();
